module.exports = __webpack_public_path__ + "static/img/Invitation-Red.c5f4bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Invitation-Red.png
// module id = ejtk
// module chunks = 1